.gripp-time-picker {
  width: 100%;
  font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding-left: 8px;
}

.gripp-time-picker .react-time-picker__wrapper {
  border: none;
  background: transparent;
}

.gripp-time-picker .react-time-picker__inputGroup {
  font-size: 16px;
}
.gripp-time-picker .react-time-picker__inputGroup__amPm {
  font-size: 16px;
  font-weight: 400;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: none;
  background: transparent;
  outline: none;
  cursor: pointer;
  padding: 0;
  margin-left: 6px;
}

.gripp-time-picker .react-time-picker__inputGroup {
  display: flex;
  align-items: center;
}
.gripp-time-picker .react-time-picker__inputGroup__leadingZero + input {
  min-width: 1ch !important;
  width: 1ch !important;
}
.gripp-time-picker .react-time-picker__inputGroup__divider:has(+ select) {
  display: none;
}
